module.exports = __webpack_public_path__ + "img/ornament-663.10114365.png";